<app-tab-form-modal [isModal]="isModal" [showSave]="showSave" [showBack]="showBack">
  <app-base-comments
    [id]="id"
    [commentService]="stockItemCommentService"
    [allowAdd]="allowAdd"
    [oneRecord]="oneRecord"
  ></app-base-comments>
</app-tab-form-modal>
